export default __webpack_public_path__ + "static/media/1976.969b9728.png";